import { RootState } from "../store";
import { CustomerType } from "./customer-types";

export const getCustomerId = (state: RootState): string =>
    state.customerReducer.id || "";

export const getCustomerType = (state: RootState): CustomerType | null =>
    state.customerReducer.type;
